// 30 verified NBA franchise codes + full names + ESPN CDN logos + official brand colors.
// Codes/logos confirmed directly from the hoopR/ESPN schedule+team_box data used by the
// backend model (e.g. team_box row's own `team_logo` field == `https://a.espncdn.com/i/
// teamlogos/nba/500/{code.toLowerCase()}.png`), NOT guessed -- the same 30 codes the backend's
// NBA_TEAM_CODES allowlist uses (services/data_ingestion/hoopr_provider.py).
export const NBA_TEAMS = {
  ATL: { name: "Atlanta Hawks", color: "#E03A3E" },
  BKN: { name: "Brooklyn Nets", color: "#000000" },
  BOS: { name: "Boston Celtics", color: "#007A33" },
  CHA: { name: "Charlotte Hornets", color: "#00788C" },
  CHI: { name: "Chicago Bulls", color: "#CE1141" },
  CLE: { name: "Cleveland Cavaliers", color: "#860038" },
  DAL: { name: "Dallas Mavericks", color: "#00538C" },
  DEN: { name: "Denver Nuggets", color: "#0E2240" },
  DET: { name: "Detroit Pistons", color: "#C8102E" },
  GS: { name: "Golden State Warriors", color: "#1D428A" },
  HOU: { name: "Houston Rockets", color: "#CE1141" },
  IND: { name: "Indiana Pacers", color: "#002D62" },
  LAC: { name: "LA Clippers", color: "#C8102E" },
  LAL: { name: "Los Angeles Lakers", color: "#552583" },
  MEM: { name: "Memphis Grizzlies", color: "#5D76A9" },
  MIA: { name: "Miami Heat", color: "#98002E" },
  MIL: { name: "Milwaukee Bucks", color: "#00471B" },
  MIN: { name: "Minnesota Timberwolves", color: "#0C2340" },
  NO: { name: "New Orleans Pelicans", color: "#0C2340" },
  NY: { name: "New York Knicks", color: "#006BB6" },
  OKC: { name: "Oklahoma City Thunder", color: "#007AC1" },
  ORL: { name: "Orlando Magic", color: "#0077C0" },
  PHI: { name: "Philadelphia 76ers", color: "#006BB6" },
  PHX: { name: "Phoenix Suns", color: "#1D1160" },
  POR: { name: "Portland Trail Blazers", color: "#E03A3E" },
  SA: { name: "San Antonio Spurs", color: "#C4CED4" },
  SAC: { name: "Sacramento Kings", color: "#5A2D81" },
  TOR: { name: "Toronto Raptors", color: "#CE1141" },
  UTAH: { name: "Utah Jazz", color: "#002B5C" },
  WSH: { name: "Washington Wizards", color: "#002B5C" },
};

export const getNbaTeamInfo = (code) => ({
  name: NBA_TEAMS[code]?.name || code,
  logo_url: code ? `https://a.espncdn.com/i/teamlogos/nba/500/${code.toLowerCase()}.png` : null,
  color: NBA_TEAMS[code]?.color || null,
});
